export default __webpack_public_path__ + "static/media/sidebar-icon-5.89bda76a.svg";